export const COMPANYREMINDERLOGLIST_SEARCH = 'COMPANYREMINDERLOGLIST_SEARCH';
export const COMPANYREMINDERLOGLIST_PAGE = 'COMPANYREMINDERLOGLIST_PAGE';
export const COMPANYREMINDERLOGLIST_STARTDATE = 'COMPANYREMINDERLOGLIST_STARTDATE';
export const COMPANYREMINDERLOGLIST_ENDDATE = 'COMPANYREMINDERLOGLIST_ENDDATE';
export const COMPANYREMINDERLOGLIST_USER = 'COMPANYREMINDERLOGLIST_USER';
export const COMPANYREMINDERLOGLIST_COUNTRY = 'COMPANYREMINDERLOGLIST_COUNTRY';